<template>
    <label class="headline-modal">{{ $t("Theme") }}</label>
    <select name="theme" v-model="theme" class="form-select">
        <option value="dark">{{ $t("Dark") }}</option>
        <option value="light">{{ $t("Light") }}</option>
    </select>
    <div v-if="error_name" class="error-message">{{ error_name }}</div>
    <label class="headline-modal">{{ $t("Language") }}</label>
    <select class="form-control form-select" v-model="lang" @change="changeLocale">
        <option v-for="l in languages" :key="l.id" :value="l.id">{{ l.name }}</option>
    </select>
    <label class="headline-modal">{{ $t("Log out") }}</label>
    <button type="button" class="btn btn-cancel mb-2" @click="loginOut">{{ $t("Log out") }}</button>

    <div v-if="error" class="error-message">{{ error }}</div>
    <LogoutModal v-if="displayModalLogout" v-model:display="displayModalLogout"></LogoutModal>
</template>

<script lang="ts">
import { ColorThemeName, getTheme, setTheme } from "@/control/app-preferences";
import { defineComponent } from "vue";
import LogoutModal from "@/components/modals/auth/LogoutModal.vue";
import { useVModel } from "@/utils/v-model";
import { AVAILABLE_LANGUAGES, getLanguage, setLanguage } from "@/i18n";

export default defineComponent({
    name: "GeneralOptionsPage",
    components: {
        LogoutModal,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data: function () {
        return {
            error_name: "",
            error: "",
            theme: getTheme(),
            displayModalLogout: false,
            languages: AVAILABLE_LANGUAGES.map((l) => {
                return { id: l.id, name: l.name };
            }),
            lang: getLanguage(),
            busy: false,
        };
    },
    methods: {
        loginOut: function () {
            this.displayModalLogout = !this.displayModalLogout;
        },

        updateTheme: function (newTheme: ColorThemeName) {
            if (newTheme && newTheme !== getTheme()) {
                setTheme(newTheme);
            }
        },
        changeLocale: function () {
            setLanguage(this.lang);
        },
    },
    mounted: function () {},
    watch: {
        theme: function (newValue: ColorThemeName) {
            this.updateTheme(newValue);
        },
    },
});
</script>

<style></style>
